<div class="dropdown-button" #dropdownButton>
  <button type="button" (click)="toggleDropdown()"
    class="mt-1 block w-full px-2 py-1 bg-white text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-header focus:border-header sm:text-sm flex justify-between items-center dark:border-0 dark:bg-dark-background-alt dark:text-gray-200">
    <div class="flex items-center justify-center flex-grow h-[28px]">
      <lucide-icon [name]="selectedIcon" class="h-5 w-5 mx-auto"></lucide-icon>
    </div>
    <lucide-icon name="chevron-down" class="h-4 w-4"></lucide-icon>
  </button>
  <div *ngIf="isOpen" class="dropdown-panel" #dropdownPanel>
    <div class="sticky top-0 bg-white dark:bg-dark-background border-b border-gray-200 dark:border-gray-700 p-2 z-10">
      <input type="text" [value]="searchTerm()" (input)="onSearchInput($any($event.target).value)"
        placeholder="Search icons..."
        class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-header focus:border-header dark:border-0 dark:bg-dark-background-alt dark:text-gray-200"
        (click)="$event.stopPropagation()">
    </div>
    <div class="grid grid-cols-6 gap-2 p-3">
      <button *ngFor="let icon of filteredIcons()" type="button"
        class="cursor-pointer flex justify-center items-center hover:bg-gray-100 dark:hover:bg-dark-background-alt p-2 rounded-lg transition-colors"
        (click)="selectIcon(icon.name)">
        <lucide-icon [name]="icon.name"
          class="h-5 w-5 text-gray-800 dark:text-white hover:dark:text-gray-200 hover:text-blue-500"></lucide-icon>
      </button>
    </div>
    <p *ngIf="filteredIcons().length === 0" class="px-3 pb-3 text-sm text-gray-500 dark:text-gray-400">
      No icons match your search.
    </p>
  </div>
</div>
